import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../../base';
import Icon from '@mdi/react';

export const FilterIconButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 4px;
    margin-left: 4px;
    cursor: pointer;
    opacity: 1;
    transition: color 0.2s;
    color: ${Variables.Colors.n50};

    &:hover {
        color: ${Variables.Colors.n70};
    }

    &.active {
        color: ${Variables.Colors.b300};
    }
`;

export const FilterPopoverContent = styled.div`
    padding: 16px;
    min-width: 280px;
    max-width: 400px;
`;

export const FilterLabel = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${Variables.Colors.n85};
    margin-bottom: 8px;
`;

export const FilterMethodRow = styled.div`
    margin-bottom: 12px;
`;

export const FilterValueRow = styled.div`
    margin-bottom: 12px;
`;

export const FilterActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
`;

export const ApplyButton = styled(BaseButton)`
    min-width: 60px;
`;

export const ClearButton = styled(BaseButton)`
    min-width: 60px;
`;

export const FilterIcon = styled(Icon)`
    width: 16px;
    height: 16px;
`;

